export const WIDGET_ROLES = {
    RELATED_POSTS: 'wix-blog-related-posts',
    COMMENTS: 'wix-blog-comments',
};
//# sourceMappingURL=widget-roles.js.map